import { FormSection, Link, Timeline } from '@ksyos/design-system';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { useProcessStartWizardWithCards } from '@frontend/utils/hooks/useProcessStartWizardWithCards';

export function TooV1FollowingSteps() {
    const hasProcessStartWizardWithCards = useProcessStartWizardWithCards();
    const selectedEmploymentId = useSelector((state: IReduxState) => state.authentication.selectedEmploymentId);

    if (!hasProcessStartWizardWithCards) {
        return null;
    }

    return (
        <FormSection title="Vervolgstappen optometrisch onderzoek">
            <Timeline>
                <Timeline.Item>
                    De patiënt kan binnen 3 werkdagen terecht bij een optiekzaak in de buurt (waar een Ksyos optometrist
                    werkzaam is) door telefonisch een afspraak te maken
                </Timeline.Item>
                <Timeline.Item>De Ksyos optometrist voert het onderzoek uit</Timeline.Item>
                <Timeline.Item>Een Ksyos oogarts kijkt altijd digitaal mee</Timeline.Item>
                <Timeline.Item>
                    Je ontvangt de uitslag in het Ksyos platform en via Edifact in je HIS als je je{' '}
                    <Link
                        openInNewTab={true}
                        to={`/employments/${selectedEmploymentId}/personalSettings`}
                        variant="link"
                    >
                        zorgmailnummer hebt doorgegeven
                    </Link>
                </Timeline.Item>
            </Timeline>
        </FormSection>
    );
}
